/**
 * variant-home-link.js
 * ---------------------------------------------------------------------------
 * 让面包屑的 Home 链接跟随「当前实际显示的那一套页头」的 Logo 链接。
 *
 * 背景：两套页头（页头 1 / 页头 2）会同时输出到页面上，由
 *       snippets/layout-variant-rules.liquid 生成的 CSS 决定当前显示哪一套，
 *       所以只有到了浏览器里才能确定到底是哪一套在显示。
 *
 * 逻辑：
 *   1. 找到没有被隐藏的那一套页头（.header-1 / .header-2）
 *   2. 取出其中可见的 Logo 链接 data-logo-link 的 href
 *   3. 把面包屑里带 data-breadcrumb-home 的链接同步成同一个地址
 *
 * Liquid 已经输出了正确的基础值（无 JS 时也对），这里只做最终校准。
 */
(function () {
  var HOME_SELECTOR = '[data-breadcrumb-home]';
  var LOGO_SELECTOR = '[data-logo-link]';

  // 沿祖先链判断：桌面端 / 移动端两份 Logo 是靠父容器的媒体查询隐藏的，
  // 只查元素自身的 display 会漏判。
  function isDisplayed(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (window.getComputedStyle(node).display === 'none') return false;
      node = node.parentElement;
    }
    return !!el;
  }

  function visibleLogoHref() {
    // 文档顺序找到第一套没有被规则隐藏的页头
    var sections = document.querySelectorAll('.header-2, .header-1');
    for (var i = 0; i < sections.length; i++) {
      if (!isDisplayed(sections[i])) continue;

      var logos = sections[i].querySelectorAll(LOGO_SELECTOR);
      for (var j = 0; j < logos.length; j++) {
        if (!isDisplayed(logos[j])) continue;
        var href = logos[j].getAttribute('href');
        if (href && href !== '#') return href;
      }
    }
    return null;
  }

  function sync() {
    var homes = document.querySelectorAll(HOME_SELECTOR);
    if (!homes.length) return;

    var href = visibleLogoHref();
    if (!href) return;

    for (var i = 0; i < homes.length; i++) {
      if (homes[i].getAttribute('href') !== href) {
        homes[i].setAttribute('href', href);
      }
    }
  }

  function run() {
    try {
      sync();
    } catch (e) {
      /* 页面结构异常时不影响其它功能 */
    }
  }

  // 立即跑一次：本脚本在 body 末尾加载，此时面包屑 DOM 已经存在，
  // 不用等 DOMContentLoaded，同步时机比 head 里的 defer 脚本早得多。
  run();

  // DOM 解析完成、资源加载完成时各补一次（覆盖异步插入的面包屑）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  window.addEventListener('load', run);

  // 主题内有局部刷新（筛选、搜索建议、抽屉等）时保持同步
  if (window.MutationObserver) {
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(run, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // 供其它脚本调用：window.syncBreadcrumbHomeLink()
  window.syncBreadcrumbHomeLink = run;
})();
